// Due dates are days, not times: stored as 9am local on the day, overdue from the next day.
const dayKey = (d: Date) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

export function dueGroup(dueAt: string | null, now = new Date()): "overdue" | "today" | "later" | "none" {
	if (!dueAt) return "none";
	const due = new Date(dueAt);
	if (dayKey(due) === dayKey(now)) return "today";
	return due < startOfDay(now) ? "overdue" : "later";
}

export function dueLabel(dueAt: string | null, now = new Date()): string {
	if (!dueAt) return "";
	const due = new Date(dueAt);
	const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
	const group = dueGroup(dueAt, now);
	const day = due.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
	if (group === "today") return "Today";
	if (group === "overdue") return `Overdue, was due ${day}`;
	if (dayKey(due) === dayKey(tomorrow)) return "Tomorrow";
	return day;
}

/** 9am on the chosen day, local time. "Next week" is next Monday. */
export function dueFrom(when: string, picked: string, now = new Date()): string | null {
	const at9 = (y: number, m: number, d: number) => new Date(y, m, d, 9, 0, 0).toISOString();
	const [y, m, d] = [now.getFullYear(), now.getMonth(), now.getDate()];
	if (when === "today") return at9(y, m, d);
	if (when === "tomorrow") return at9(y, m, d + 1);
	if (when === "week") return at9(y, m, d + ((8 - now.getDay()) % 7 || 7));
	if (when === "date" && picked) {
		const [py, pm, pd] = picked.split("-").map(Number) as [number, number, number];
		return at9(py, pm - 1, pd);
	}
	return null;
}
